import { axiosInstance } from "api/axios-config/axios-config";

export interface ApiBuildInfo {
  gitHash?: string;
  buildDate?: string;
}

export const getApiBuildInfo = async (): Promise<ApiBuildInfo | undefined> => {
  try {
    const response = await axiosInstance.get<ApiBuildInfo>("/api/build-info", {
      timeout: 5000,
    });
    return response.data;
  } catch {
    return undefined;
  }
};